import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CottageServices from '../../services/CottageServices';
import CategoryServices from '../../services/CategoryServices';
import CouponServices from '../../services/CouponServices';
import ReactQuill from 'react-quill';
import Pagetitle from '../../component/PageTitle';
import Select from 'react-select';

function AddNewCottage() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    address: '',
    lat: '',
    long: '',
    hostedBY: '',
    name: '',
    benefit: [''],
    category: [''],
    description: '',
    price: '',
    offerPrice: '',
    discountPercentage: '',
    location: '',
    tax: '',
    cancelPrice: '',
    datechangePrice: '',
    early: false,
    bookWithZeroUPFront: false,
    roomDetails: '',
    beds: '',
    coupon: [''],
    bathrooms: '',
    rulesAndRegulations: '',
    cancelPolicy: '',
    foodDescription: '',
    foodkey: [{
      name: '',
      describe: ''
    }],
    travelTimes: {
      checkInTime: '',
      checkOutTime: '',
      guestLimit: '',
    },
    propertyLayout: [{
      propertyImage: '',
      roomType: '',
      roomDescription: '',
      numberOfBeds: '',
      attachedBathroom: false,
    }],
    guestCapacity: '',
    images: [],
    swimmingPool: false,
    ac: false,
    wifi: false,
    parking: false,
    livingArea: false,
    breakfast: false,
    lunch: false,
    dinner: false,
  });
  const [categories, setCategories] = useState([]);
  const [coupon, setCoupon] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [previewImages1, setPreviewImages1] = useState([]);
  const [uploading, setUploading] = useState(false);

  const [price, setPrice] = useState(0);
  const [offerPrice, setOfferPrice] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);

  const handlePropertyChange = (index, field, value) => {
    const updatedPropertyLayout = [...formValues.propertyLayout];
    updatedPropertyLayout[index][field] = value;
    setFormValues({
      ...formValues,
      propertyLayout: updatedPropertyLayout,
    });
  };

  // Add more rooms
  const addRoom = () => {
    setFormValues({
      ...formValues,
      propertyLayout: [
        ...formValues.propertyLayout,
        { roomType: '', roomDescription: '', numberOfBeds: '', propertyImage: '', attachedBathroom: false },
      ],
    });
  };

  // Remove a room
  const removeRoom = (index) => {
    const updatedPropertyLayout = formValues.propertyLayout.filter((_, i) => i !== index);
    setFormValues({
      ...formValues,
      propertyLayout: updatedPropertyLayout,
    });
  };


  const handleFoodChange = (index, field, value) => {
    const updatedfoodkey = [...formValues.foodkey];
    updatedfoodkey[index][field] = value;
    setFormValues({
      ...formValues,
      foodkey: updatedfoodkey,
    });
  };

  // Add more rooms
  const addFood = () => {
    setFormValues({
      ...formValues,
      foodkey: [
        ...formValues.foodkey,
        { name: '', describe: '' },
      ],
    });
  };

  // Remove a room
  const removeFood = (index) => {
    const updatedfoodkey = formValues.foodkey.filter((_, i) => i !== index);
    setFormValues({
      ...formValues,
      foodkey: updatedfoodkey,
    });
  };

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: checked,
    }));
  };
  const handleMealCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [id]: checked,
    }));
  };
  // Calculate discount percentage whenever price or offerPrice changes
  useEffect(() => {
    if (price && offerPrice) {
      const calculatedDiscount = Math.round((1 - offerPrice / price) * 100);
      setDiscountPercentage(calculatedDiscount);
    } else {
      setDiscountPercentage(0);
    }
  }, [price, offerPrice]);

  const handleQuillChange = (name, value) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  };
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await CategoryServices.getCategoryActive();
        if (res.status) {
          setCategories(res.data);
        } else {
          alert('Failed to fetch categories');
        }
      } catch (error) {
        console.error('Error fetching categories', error);
        alert('Failed to fetch categories');
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchCoupon = async () => {
      try {
        const res = await CouponServices.getCoupon();
        if (res.status) {
          setCoupon(res.data);
        } else {
          alert('Failed to fetch coupon');
        }
      } catch (error) {
        console.error('Error fetching coupon', error);
        alert('Failed to fetch coupon');
      }
    };
    fetchCoupon();
  }, []);

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;

  //   if (name === 'price') {
  //     setPrice(value);
  //   } else if (name === 'offerPrice') {
  //     setOfferPrice(value);
  //   } else {
  //     setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  //   }
  // };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === 'price') {
      setPrice(value);
    } else if (name === 'offerPrice') {
      setOfferPrice(value);
    } else if (name.includes('.')) {
      // Handle nested fields
      const keys = name.split('.');
      setFormValues((prevValues) => ({
        ...prevValues,
        [keys[0]]: {
          ...prevValues[keys[0]],
          [keys[1]]: value,
        },
      }));
    } else {
      // Handle top-level fields
      setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
    }
  };

  const handleBenefitChange = (index, event) => {
    const updatedBenefit = formValues.benefit.map((benefit, i) =>
      i === index ? event.target.value : benefit
    );
    setFormValues((prevValues) => ({ ...prevValues, benefit: updatedBenefit }));
  };

  const addBenefit = () => {
    setFormValues((prevValues) => ({ ...prevValues, benefit: [...prevValues.benefit, ''] }));
  };

  const removeBenefit = (index) => {
    const updatedBenefit = formValues.benefit.filter((_, i) => i !== index);
    setFormValues((prevValues) => ({ ...prevValues, benefit: updatedBenefit }));
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const validFormats = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    const filteredFiles = files.filter((file) => validFormats.includes(file.type));

    if (filteredFiles.length === 0) {
      alert("Please upload valid image files (png, jpeg, jpg, webp).");
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      filteredFiles.forEach((file) => formData.append('images', file));
      const response = await CottageServices.uploadImage(formData);
      if (response && Array.isArray(response.images)) {
        const uploadedImages = response.images.map((imagePath) => {
          const normalizedPath = imagePath.replace(/\\/g, '/');
          return `${normalizedPath}`;
        });

        setFormValues((prevValues) => ({
          ...prevValues,
          images: [...prevValues.images, ...uploadedImages],
        }));
        setPreviewImages((prevPreviews) => [...prevPreviews, ...uploadedImages]);
      } else {
        console.error('Unexpected response format:', response);
        throw new Error('Image upload failed: Invalid response format');
      }
    } catch (error) {
      console.error('Image upload failed', error);
      alert('Failed to upload images. Please try again.');
    } finally {
      setUploading(false);
      event.target.value = null;
    }
  };
  const handlePropertyFileChange = async (event, index) => {
    const file = event.target.files[0]; // Single file instead of multiple
    const validFormats = ["image/png", "image/jpeg", "image/jpg", "image/webp"];

    if (!file || !validFormats.includes(file.type)) {
      alert("Please upload a valid image file (png, jpeg, jpg, webp).");
      return;
    }

    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('propertyImage', file); // Key should match Multer config

      const response = await CottageServices.uploadPropertyImage(formData);
      console.log("response:",response);

      // Handle response (direct access to the image path)
      if (response && response.propertyImage) {
        const normalizedPath = response.propertyImage.replace(/\\/g, '/');

        // Update the specific room's property image
        const updatedPropertyLayout = [...formValues.propertyLayout];
        updatedPropertyLayout[index].propertyImage = normalizedPath;

        setFormValues({
          ...formValues,
          propertyLayout: updatedPropertyLayout,
        });

        // Update preview images
        setPreviewImages1((prevPreviews) => [...prevPreviews, normalizedPath]);

      } else {
        console.error('Unexpected response format:', response);
        throw new Error('Image upload failed: Invalid response format');
      }

    } catch (error) {
      console.error('Image upload failed', error);
      alert('Failed to upload image. Please try again.');
    } finally {
      setUploading(false);
      event.target.value = null;
    }
  };




  const handleRemoveImage = async (imageUrl) => {
    try {
      const response = await CottageServices.removeImage({ url: imageUrl });
      if (response.status) {
        setFormValues((prevValues) => ({
          ...prevValues,
          images: prevValues.images.filter((image) => image !== imageUrl),
        }));
        setPreviewImages((prevPreviews) => prevPreviews.filter((image) => image !== imageUrl));
        alert('Image removed successfully!');
      } else {
        alert('Failed to remove image from server');
      }
    } catch (error) {
      console.error('Failed to remove image', error);
      alert('Failed to remove image');
    }
  };


  const handleRemovePropertyImage = async (imageUrl, index) => {
    try {
      console.log('Removing image:', imageUrl); 
  
      const response = await CottageServices.removeImage({ url: imageUrl });
  
      console.log('Remove image response:', response);
  
      // Check if the image removal was successful
      if (response && response.status) {
        // Remove the image from the specific room layout
        const updatedPropertyLayout = [...formValues.propertyLayout];
        updatedPropertyLayout[index].propertyImage = '';  // Clear the image
  
        setFormValues((prevValues) => ({
          ...prevValues,
          propertyLayout: updatedPropertyLayout,
        }));
  
        // Update the preview list by filtering out the removed image
        setPreviewImages1((prevPreviews) =>
          prevPreviews.filter((image) => image !== imageUrl)
        );
  
        alert('Image removed successfully!');
      } else {
        alert('Failed to remove image from the server');
      }
    } catch (error) {
      console.error('Failed to remove image', error);
      alert('Error occurred while removing the image');
    }
  };
  
  

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const payload = {
        ...formValues, price,
        offerPrice,
        discountPercentage,
      };
      // If your backend expects images as an array of URLs, no need to convert
      // If it expects something else, adjust accordingly

      const response = await CottageServices.createCottage(payload);
      if (response.status) {
        alert('Cottage created successfully');
        navigate('/cottage-list');
      } else {
        alert('Failed to Cottage service');
      }
    } catch (error) {
      console.error('Failed to create service:', error);
      alert(error.response?.data?.message || 'Failed to create service details');
    }
  };

  const handleCouponChange = (selectedOptions) => {
    const selectedCoupons = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setFormValues((prevValues) => ({ ...prevValues, coupon: selectedCoupons }));
  };

  const couponOptions = coupon.map((cou) => ({
    value: cou._id,
    label: cou.name,
  }));

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <form onSubmit={handleSubmit}>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Cottage Information Section</h4>
            <div className="sub-title-box-right">

              <Link className="site-btn-green" to="/cottage-list">
                Cottage List
              </Link>
            </div>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">

              <div className="row">
                <div className="col-lg-4">
                  <div className="input-field">
                    <label>category Name*</label>
                    <select
                      name="category"
                      className="form-control"
                      value={formValues.category}
                      onChange={handleInputChange}

                    >
                      <option value="">Select a category</option>
                      {categories.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="input-field">
                    <label>Cottage Name*</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formValues.name}
                      onChange={handleInputChange}
                      placeholder="Enter Cottage Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="input-field">
                    <label>Address*</label>
                    <input
                      type="text"
                      name="address"
                      className="form-control"
                      value={formValues.address}
                      onChange={handleInputChange}
                      placeholder="Enter Address"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="input-field">
                    <label>Lat*</label>
                    <input
                      type="number"
                      name="lat"
                      className="form-control"
                      value={formValues.lat}
                      onChange={handleInputChange}
                      placeholder="Enter Latitude"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="input-field">
                    <label>Long*</label>
                    <input
                      type="number"
                      name="long"
                      className="form-control"
                      value={formValues.long}
                      onChange={handleInputChange}
                      placeholder="Enter Longitude"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="input-field">
                    <label>Hosted Name*</label>
                    <input
                      type="text"
                      name="hostedBY"
                      className="form-control"
                      value={formValues.hostedBY}
                      onChange={handleInputChange}
                      placeholder="Enter hosted name"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="input-field">
                    <label>Location*</label>
                    <input
                      type="text"
                      name="location"
                      className="form-control"
                      value={formValues.location}
                      onChange={handleInputChange}
                      placeholder="Enter Location"
                      required
                    />
                  </div>
                </div>
                <div className='col-lg-3 col-sm-3' >
                  <div className="input-field">
                    <label>Main Price*</label>
                    <input type="number" name="price" value={price} onChange={handleInputChange}
                      defaultValue="Product scanning" className="form-control" required />
                  </div>
                </div>
                <div className='col-lg-3 col-sm-3' >
                  <div className="input-field">
                    <label>Offer Price*</label>
                    <input type="number" name="offerPrice" value={offerPrice} onChange={handleInputChange}
                      defaultValue="Product scanning" className="form-control" required />
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="input-field">
                    <label>Tax(%)*</label>
                    <input
                      type="number"
                      name="tax"
                      className="form-control"
                      value={formValues.tax}
                      onChange={handleInputChange}
                      placeholder="Enter Tax"
                      required
                    />
                  </div>
                </div>
                <div className='col-lg-3 col-sm-3' >
                  <div className="input-field">
                    <label>Discount Percentage*</label>
                    <input type="number" name="discountPercentage" value={discountPercentage}
                      readOnly
                      onChange={handleInputChange} defaultValue="Product scanning" className="form-control" required />
                  </div>
                </div>
                <div className='col-lg-3 col-sm-3' >
                  <div className="input-field">
                    <label>Early*</label>
                    <select className="form-control" value={formValues.early}
                      onChange={handleInputChange} name="early" required>
                      <option value="">--Select Type--</option>
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </select>
                  </div>
                </div>
                <div className='col-lg-3 col-sm-3' >
                  <div className="input-field">
                    <label>Booking Up Fornt*</label>
                    <select className="form-control" value={formValues.bookWithZeroUPFront}
                      onChange={handleInputChange} name="bookWithZeroUPFront" required>
                      <option value="">--Select Type--</option>
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </select>
                  </div>
                </div>
                <div className='col-lg-3 col-sm-3' >
                  <div className="input-field">
                    <label>Cancel Price*</label>
                    <input type="number" name="cancelPrice" value={formValues.cancelPrice} onChange={handleInputChange}
                      defaultValue="Product scanning" className="form-control" required />
                  </div>
                </div>
                <div className='col-lg-3 col-sm-3' >
                  <div className="input-field">
                    <label>Date Change Price*</label>
                    <input type="number" name="datechangePrice" value={formValues.datechangePrice} onChange={handleInputChange}
                      defaultValue="Product scanning" className="form-control" required />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="input-field">
                    <label>Description</label>
                    <ReactQuill
                      theme="snow"
                      value={formValues.description}
                      onChange={(value) => handleQuillChange('description', value)}
                      placeholder="Description"
                      className="form-control"
                      minLength={10}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="input-field">
                    <label>Benefit*</label>
                    {formValues.benefit.map((benefit, index) => (
                      <div key={index} className="input-group mb-2">
                        <input
                          type="text"
                          className="form-control"
                          value={benefit}
                          onChange={(event) => handleBenefitChange(index, event)}
                          placeholder="benefit description"
                          required
                        />
                        <div className="input-group-append">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => removeBenefit(index)}
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    ))}
                    <button
                      type="button"
                      className="btn btn-secondary mt-2"
                      onClick={addBenefit}
                    >
                      + Add Benefit Item
                    </button>
                  </div>
                </div>
                {/* Image upload */}
                <div className="col-lg-12">
                  <div className="input-field">
                    <label>Upload Images*</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleFileChange}
                      multiple
                    />
                    <p>Supported formats: png, jpeg, jpg, webp</p>
                    <div className="image-preview-container-service image-preview-container-service-2">
                      {previewImages.map((image, index) => (
                        <div key={index} className="preview-image">
                          <img src={`${process.env.REACT_APP_URL}${image}`}
                            alt="preview" style={{ width: 100 }} />
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleRemoveImage(image)}
                          >
                            X
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Accommodation Details</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">

              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>Room Details</label>
                    <input
                      type="text"
                      name="roomDetails"
                      className="form-control"
                      value={formValues.roomDetails}
                      onChange={handleInputChange}
                      placeholder="Enter Number of Room Details"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>No. of Beds</label>
                    <input
                      type="text"
                      name="beds"
                      className="form-control"
                      value={formValues.beds}
                      onChange={handleInputChange}
                      placeholder="Enter No. of Beds"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>No. of bathrooms</label>
                    <input
                      type="text"
                      name="bathrooms"
                      className="form-control"
                      value={formValues.bathrooms}
                      onChange={handleInputChange}
                      placeholder="Enter No. of bathrooms"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="input-field">
                    <label>Guest Capacity</label>
                    <input
                      type="text"
                      name="guestCapacity"
                      className="form-control"
                      value={formValues.guestCapacity}
                      onChange={handleInputChange}
                      placeholder="Enter Guest Capacity"
                      required
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Amenities</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">
              <div className="row">
                {['swimmingPool', 'ac', 'wifi', 'parking', 'livingArea'].map((field) => (
                  <div className="col-md-2" key={field}>
                    <div className="mb-3 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={field}
                        checked={formValues[field]}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor={field}>
                        {field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1')}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Meal</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">
              <div className="row">
                {['breakfast', 'lunch', 'dinner'].map((field) => (
                  <div className="col-md-2" key={field}>
                    <div className="mb-3 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={field}
                        checked={formValues[field]}
                        onChange={handleMealCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor={field}>
                        {field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1')}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Booking Information</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">

              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Select Coupon Code</label>
                    <Select
                      isMulti
                      name="coupon"
                      options={couponOptions}
                      value={couponOptions.filter(option => formValues.coupon.includes(option.value))}
                      onChange={handleCouponChange}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Travel Dates & Guests</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">

              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Check-in Time</label>
                    <input
                      type="text"
                      name="travelTimes.checkInTime"
                      className="form-control"
                      value={formValues.travelTimes.checkInTime}
                      onChange={handleInputChange}
                      placeholder="Check-in Time"

                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Check-out Time</label>
                    <input
                      type="text"
                      name="travelTimes.checkOutTime"
                      className="form-control"
                      value={formValues.travelTimes.checkOutTime}
                      onChange={handleInputChange}
                      placeholder="Enter Check-out Time"

                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Guest Limit</label>
                    <input
                      type="text"
                      name="travelTimes.guestLimit"
                      className="form-control"
                      value={formValues.travelTimes.guestLimit}
                      onChange={handleInputChange}
                      placeholder="Enter Guest Limit"

                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Property Layout</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">
              {formValues.propertyLayout.map((room, index) => (
                <div className="row mb-4" key={index}>
                  <div className="col-lg-3 col-md-6">
                    <div className="input-field">
                      <label>Room Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={room.roomType}
                        onChange={(e) => handlePropertyChange(index, 'roomType', e.target.value)}
                        placeholder="Enter Room Title"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6">
                    <div className="input-field">
                      <label>Room Description</label>
                      <input
                        type="text"
                        className="form-control"
                        value={room.roomDescription}
                        onChange={(e) => handlePropertyChange(index, 'roomDescription', e.target.value)}
                        placeholder="Enter Room Description"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-6">
                    <div className="input-field">
                      <label>Number of Beds</label>
                      <input
                        type="number"
                        className="form-control"
                        value={room.numberOfBeds}
                        onChange={(e) => handlePropertyChange(index, 'numberOfBeds', e.target.value)}
                        placeholder="Enter Number of Beds"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="mb-3 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`attachedBathroom-${index}`}
                        checked={room.attachedBathroom}
                        onChange={(e) => handlePropertyChange(index, 'attachedBathroom', e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor={`attachedBathroom-${index}`}>
                        Attached Bathroom
                      </label>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="input-field">
                      <label>Upload Images*</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={(e) => handlePropertyFileChange(e, index)} // Pass index to handlePropertyFileChange
                      />
                      <p>Supported formats: png, jpeg, jpg, webp</p>
                      <div className="image-preview-container-service image-preview-container-service-2">
                        {previewImages1.length == index ? '':
                          <div key={index} className="preview-image">
                            <img src={`${process.env.REACT_APP_URL}${previewImages1[index]}`}  style={{ width: 100 }} />
                           
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => handleRemovePropertyImage(previewImages1[index], index)} 
                            >
                              X
                            </button>
                            
                            
                          </div>
}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeRoom(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}

              <button type="button" className="btn btn-secondary" onClick={addRoom}>
                Add More
              </button>
            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Food & Dining</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="row">
              <div className="col-lg-12 col-md-6">
                <div className="input-field">
                  <label>Food Description</label>
                  <ReactQuill
                    theme="snow"
                    value={formValues.foodDescription}
                    onChange={(value) => handleQuillChange('foodDescription', value)}
                    placeholder="Food Description"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="page-details">
              {formValues.foodkey.map((food, index) => (
                <div className="row mb-4" key={index}>
                  <div className="col-lg-3 col-md-6">
                    <div className="input-field">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={food.name}
                        onChange={(e) => handleFoodChange(index, 'name', e.target.value)}
                        placeholder="Enter Category Name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Describe</label>
                      <input
                        type="text"
                        className="form-control"
                        value={food.describe}
                        onChange={(e) => handleFoodChange(index, 'describe', e.target.value)}
                        placeholder="Enter  Description"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-2 d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeFood(index)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}

              <button type="button" className="btn btn-secondary" onClick={addFood}>
                Add More
              </button>
            </div>
          </div>
        </div>
        <div className="container-box">
          <div className="container-box-top-header justify-content-between">
            <h4>Rules and Regulations</h4>
          </div>
          <div className="container-box-inner px-4">
            <div className="page-details">
              <div className="row">
                <div className="col-lg-12">
                  <div className="input-field">
                    <label>Description</label>

                    <ReactQuill
                      theme="snow"
                      value={formValues.rulesAndRegulations}
                      onChange={(value) => handleQuillChange('rulesAndRegulations', value)}
                      placeholder=" Description"
                      className="form-control"
                      minLength={10}
                    />

                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="input-field">
                    <label>Inclusion & cancellation policy</label>
                    <ReactQuill
                      theme="snow"
                      value={formValues.cancelPolicy}
                      onChange={(value) => handleQuillChange('cancelPolicy', value)}
                      placeholder="Cancel Policy"
                      className="form-control"
                      minLength={10}
                    />
                  </div>
                </div>
              </div>
              <button className="site-btn-green" type="submit">
                Save Cottage
              </button>

            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddNewCottage;
